import { baseTheme } from "./base";
const overrideColors = {
    heroPineGreen: "#26513B",
    springLeaves: "#4B7155",
    laurel: "#6C906E",
};
const colors = Object.assign(Object.assign(Object.assign({}, baseTheme.colors), overrideColors), { cl17: overrideColors.heroPineGreen, cl18: overrideColors.springLeaves, cl19: overrideColors.laurel });
colors.primaryLight = colors.cl17;
colors.primary = colors.cl18;
colors.primaryDark = colors.cl19;
const headlines = {
    h1: {
        title: {
            uppercase: true,
            fontWeight: 400,
        },
        subtitle: {
            uppercase: true,
            fontWeight: 400,
        },
        sizes: {
            xsmall: baseTheme.fontTokens.font05,
            medium: baseTheme.fontTokens.font03,
            large: baseTheme.fontTokens.font02,
            xlarge: baseTheme.fontTokens.font01,
        },
    },
    h2: {
        title: {
            uppercase: false,
            fontWeight: 400,
        },
        subtitle: {
            uppercase: false,
            fontWeight: 400,
        },
        sizes: {
            xsmall: baseTheme.fontTokens.font07,
            medium: baseTheme.fontTokens.font06,
            large: baseTheme.fontTokens.font05,
            xlarge: baseTheme.fontTokens.font04,
        },
    },
    h3: {
        title: {
            uppercase: false,
            fontWeight: 700,
        },
        subtitle: {
            uppercase: false,
            fontWeight: 300,
        },
        sizes: {
            xsmall: baseTheme.fontTokens.font09,
            medium: baseTheme.fontTokens.font08,
            large: baseTheme.fontTokens.font07,
            xlarge: baseTheme.fontTokens.font07,
        },
    },
    h4: {
        title: {
            uppercase: false,
            fontWeight: 700,
        },
        subtitle: {
            uppercase: false,
            fontWeight: 300,
        },
        sizes: {
            xsmall: baseTheme.fontTokens.font10,
            medium: baseTheme.fontTokens.font10,
            large: baseTheme.fontTokens.font10,
            xlarge: baseTheme.fontTokens.font10,
        },
    },
    h5: {
        title: {
            uppercase: false,
            fontWeight: 700,
        },
        subtitle: {
            uppercase: false,
            fontWeight: 300,
        },
        sizes: {
            xsmall: baseTheme.fontTokens.font11,
            medium: baseTheme.fontTokens.font11,
            large: baseTheme.fontTokens.font11,
            xlarge: baseTheme.fontTokens.font11,
        },
    },
    h6: {
        title: {
            uppercase: false,
            fontWeight: 700,
        },
        subtitle: {
            uppercase: false,
            fontWeight: 300,
        },
        sizes: {
            xsmall: baseTheme.fontTokens.font11,
            medium: baseTheme.fontTokens.font11,
            large: baseTheme.fontTokens.font11,
            xlarge: baseTheme.fontTokens.font11,
        },
    },
};
export const nordicsTheme = Object.assign(Object.assign({}, baseTheme), { colors: Object.assign({}, colors), headlines });
